const getEddDateString = (date: string, lowerdate: string | undefined): string => {
  if (lowerdate) {
    const upper = new Date(date);
    const lower = new Date(lowerdate);
    const diffoptions = { day: 'numeric', month: 'short' };
    return `${upper.toLocaleDateString('en-IN', diffoptions)} - ${lower.toLocaleDateString(
      'en-IN',
      diffoptions
    )}`;
  }
  const event = new Date(date);
  const options = { weekday: 'short', day: 'numeric', month: 'short' };
  return event.toLocaleDateString('en-IN', options);
};

const calculateDifferenceFromToday = date => {
  const now = new Date().getTime();
  const diff = now - date;
  const diffSeconds = Math.floor(diff / 1000);
  const diffMinutes = Math.floor(diffSeconds / 60);
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);
  const diffYears = Math.floor(diffDays / 365);
  if (diffYears > 0) {
    return `Posted ${diffYears} year${diffYears > 1 ? 's' : ''} ago`;
  }
  if (diffDays > 0) {
    return `Posted ${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
  }
  if (diffHours > 0) {
    return `Posted ${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
  }
  if (diffMinutes > 0) {
    return `Posted ${diffMinutes} minute${diffMinutes > 1 ? 's' : ''} ago`;
  }
  return `Posted ${diffSeconds} second${diffSeconds > 1 ? 's' : ''} ago`;
};

const differenceFromToday = (date: string): string => {
  const date2 = new Date(date);
  const date1 = new Date();
  // To calculate the time difference of two dates
  const timeDifference = date2.getTime() - date1.getTime();

  // To calculate the no. of days between two dates
  try {
    return `${Math.round(timeDifference / (1000 * 3600 * 24))}`;
  } catch {
    return date;
  }
};

const getMedianDateTime = (upper: string, lower: string): string => {
  const upperDate = new Date(upper);
  const lowerDate = new Date(lower);
  const upperDateTimeInMS = upperDate.getTime();
  const lowerDateTimeInMS = lowerDate.getTime();

  // To calculate the time difference of two dates
  const timeDifference = upperDateTimeInMS - lowerDateTimeInMS;

  // Calculating the medianDateTime
  const halfTheTimeDifference = timeDifference / 2;
  const medianDateTime = lowerDateTimeInMS + halfTheTimeDifference;
  const medianDateObject = new Date(medianDateTime);

  return medianDateObject.toISOString();
};

const getTimerObject = (stopDate: number): string | null => {
  if (!stopDate) return '';

  let timeString = '';
  const timeFormat = new Date(stopDate).getTime();
  const now = new Date().getTime();
  const diff = timeFormat - now;

  if (diff > 0) {
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hrs = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const secs = Math.floor((diff % (1000 * 60)) / 1000);

    if (hrs) {
      timeString += `${hrs}h `;
    }

    if ((hrs && mins >= 0) || mins) {
      timeString += `${mins}m `;
    }

    if ((mins && secs >= 0) || secs) {
      timeString += `${secs}s`;
    }
    return days ? null : timeString;
  }
  return null;
};

const extractNumber = (input = '') => {
  const match = input.match(/\d+/);
  return match ? parseInt(match[0], 10) : '';
};

const getDateString = (date: string, type: string = ''): string => {
  const event = new Date(date);

  if (isNaN(event.getTime())) {
    return '';
  }

  let options = {};
  let formattedString;

  if (type === 'time') {
    options = { hour: 'numeric', minute: 'numeric', hour12: true };
    formattedString = event
      .toLocaleTimeString('en-IN', options)
      .replace(' ', '')
      .replace('am', 'AM')
      .replace('pm', 'PM');
  } else {
    options = { day: 'numeric', month: 'short' };
    formattedString = event.toLocaleDateString('en-IN', options);
  }

  return formattedString;
};

const formatDate = (dateDetails = ''): string => {
  const date = new Date(dateDetails);
  const options = { day: 'numeric', month: 'short', year: 'numeric' };
  const formattedDate = date.toLocaleDateString('en-GB', options);
  return formattedDate;
};
export {
  getEddDateString,
  differenceFromToday,
  getMedianDateTime,
  getTimerObject,
  calculateDifferenceFromToday,
  extractNumber,
  getDateString,
  formatDate
};
